import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogActions, Button } from '@mui/material';
import Navbar from '../../components/Features/Navbar';
import './../../styles/expert-co.css'

const SuiviExpert = () => {
  const [open, setOpen] = useState(true); // Dialog opens automatically on component mount
  const [acceptedGCU, setAcceptedGCU] = useState(false);

  useEffect(() => {
    document.title = 'Forfait Expert | Tsahal Connection';
  }, []);

  const handleAcceptGCU = () => {
    // Rediriger directement vers le lien Morning
    window.location.href = 'https://mrng.to/XbgysAYXQt';
  };



  return (
    <div>
      <Navbar />
      {/* Affichage du dialog de contrat */}
      {!acceptedGCU && (
        <div>
          <Dialog
            open={open}
            onClose={(event, reason) => {
              if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
                setOpen(false);
              }
            }} // Only allow dialog to close for reasons other than clicking outside or pressing escape
            disableBackdropClick
            disableEscapeKeyDown
            maxWidth="md"
            fullWidth
          >
            <DialogContent>
              <iframe
                src="https://1drv.ms/b/s!AgVanePzBHI9gakzoesZywhXdYsdkw?embed=1&em=2"
                style={{ width: '100%', height: '500px', border: 'none' }}
                title="GCU Document"
              ></iframe>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleAcceptGCU}>Accepter le contrat</Button>
            </DialogActions>
          </Dialog>
        </div>
      )}
      
      {/* Si l'utilisateur n'est pas encore arrivé sur cette page ou si le contrat n'est pas accepté */}
      {acceptedGCU && (
        <div style={{ textAlign: 'center', marginTop: '2rem' }}>
          <p>Redirection vers le paiement en cours...</p>
        </div>
      )}
    </div>
  );
};

export default SuiviExpert;
